module.exports = __webpack_public_path__ + "static/img/rank_298.e136da9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_298.png
// module id = I9jZ
// module chunks = 1